import { LoadingContext, useLocalStorage } from '@entrecode/statsapp-components';
import BottomSheet from '@entrecode/statsapp-components/components/BottomSheet'; // Import BottomSheet component
import * as Sentry from '@sentry/react';
import 'chart.js/auto'; // Fix for chart.js
import { AuthProvider } from 'oidc-react';
import { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import 'react-loading-skeleton/dist/skeleton.css';
import { RouterProvider } from 'react-router';
import router from './pages/router';

function App() {
  const [loading, setIsLoading] = useState(true);
  const [hasSeenUpdateModal, setHasSeenUpdateModal] = useLocalStorage('has-seen-update-modal-v2', false);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(!hasSeenUpdateModal);

  const handleHideForever = () => {
    setHasSeenUpdateModal(true);
    setBottomSheetOpen(false);
  };

  const inIFrame = window.top !== window.self;

  return (
    <>
      <HelmetProvider>
        <AuthProvider
          authority={import.meta.env.VITE_AUTHORITY}
          clientId={import.meta.env.VITE_CLIENT_ID}
          redirectUri={import.meta.env.VITE_REDIRECT_URI}
          silentRedirectUri={import.meta.env.VITE_SILENT_REDIRECT_URI}
          scope="openid profile email ecapi offline_access"
          loadUserInfo={false}
          autoSignIn={!inIFrame}
          onSignIn={() => {
            window.location.replace('/');
          }}
          onSignInError={(error) => {
            const message = error?.message ?? '';
            const isStaleCallback =
              message.includes('No matching state found in storage') ||
              message.includes("reading 'id_token'");
            if (!isStaleCallback) {
              Sentry.captureException(error);
            }
            window.location.replace('/');
          }}
        >
          <LoadingContext.Provider
            value={{
              loading,
              //@ts-ignore
              setIsLoading,
            }}
          >
            <BottomSheet isOpen={bottomSheetOpen} setIsOpen={setBottomSheetOpen} headline="Neu mit dieser App Version">
              <div className="text-center">
                <strong>Die Zahl “Zugänge” wurde angepasst:</strong>
                <div className="text-gray-600 leading-relaxed">
                  Ab sofort werden in der Testphase stornierte Mitgliedschaften immer als Zugang und Abgang gewertet.
                  Das war in der Vergangenheit, je nach gewähltem Zeitraum, teilweise nicht der Fall.
                </div>
              </div>
              <div className="mt-auto w-full flex justify-center">
                <button
                  onClick={handleHideForever}
                  className={'p-2 w-full rounded-lg text-center cursor-pointer bg-primary-500 text-white'}
                >
                  Nicht mehr anzeigen
                </button>
              </div>
            </BottomSheet>
            <RouterProvider router={router} />
          </LoadingContext.Provider>
        </AuthProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
